import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M12.5 6v-.001H5.207l3.146-3.146c.195-.195.195-.512 0-.707s-.512-.195-.707 0L3.645 6.145a.5003.5003 0 0 0 0 .707l4 4c.098.097.226.146.354.146s.256-.048.354-.146a.5003.5003 0 0 0 0-.707L5.207 6.999 12.5 7c2.481 0 4.5 2.019 4.5 4.5S14.981 16 12.5 16c-.276 0-.5.224-.5.5s.224.5.5.5c3.037 0 5.5-2.462 5.5-5.5S15.538 6 12.5 6zM1.001 2h1v16h-1V2z',
  ],
  height: 20,
  width: 20,
});
